import { render } from "./NotificationSettingView.vue?vue&type=template&id=72813a5d"
import script from "./NotificationSettingView.vue?vue&type=script&lang=js"
export * from "./NotificationSettingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__